import { toString } from 'lodash';
import { useEffect, useState } from 'react';
import { revokePlaceholderAssets } from 'src/hooks/api/assets/useUploadAsset';
import { IAsset } from 'src/interfaces';

export const useResourceSelector = () => {
  const [openResourceSelectorDrawer, setOpenResourceSelectorDrawer] =
    useState(false);
  const [searchVal, setSearchVal] = useState('');
  const [selectedAssets, setSelectedAssets] = useState<IAsset[]>([]);

  // Release placeholder blob memory when the image selector unmounts.
  useEffect(() => () => revokePlaceholderAssets(), []);

  const onToggleResourceSelectorDrawer = () =>
    setOpenResourceSelectorDrawer(!openResourceSelectorDrawer);

  const onChangeSearchVal = (value: string | string[]) => {
    setSearchVal(toString(value));
  };

  const onSelectedAssets = (selectedAssets: IAsset[]) => {
    setSelectedAssets(selectedAssets);
  };

  const resetSearchVal = () => {
    setSearchVal('');
  };

  return {
    openResourceSelectorDrawer,
    searchVal,
    selectedAssets,
    onToggleResourceSelectorDrawer,
    onChangeSearchVal,
    onSelectedAssets,
    resetSearchVal,
  };
};
